import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'view/atoms';
import { PopupConfirm } from 'view/molecules/PopupConfirm';
import * as S from './ReinviteGuestConfirmModal.styles';

type Props = {
  onConfirm: () => void;
  onClose: () => void;
  isConfirming?: boolean;
};

export const ReinviteGuestConfirmModal = ({
  onConfirm,
  onClose,
  isConfirming,
}: Props) => {
  const { t } = useTranslation();

  return (
    <PopupConfirm
      title={t('aPlayerPage.reinviteGuest.modalTitle')}
      yesText={t('aPlayerPage.reinviteGuest.confirm')}
      cancelText={t('aPlayerPage.reinviteGuest.cancel')}
      confirmHandler={onConfirm}
      closeHandler={onClose}
      isDisabledConfirm={isConfirming}
    >
      <S.DescriptionWrapper>
        <Text kind='body'>{t('aPlayerPage.reinviteGuest.modalLine1')}</Text>
      </S.DescriptionWrapper>
    </PopupConfirm>
  );
};
